import React__default, { createContext, useState } from 'react';

const black = "#1b2752";
const blue = "rgb(72,115,172)";
const dark_blue = "#1b2752";
const dark_grey = "rgba(87, 87, 87, 1)";
const end_base_button_colour = "rgba(80, 134, 198, 1)";
const end_base_button_colour_opaque = "rgba(80, 134, 198, 0.5)";
const green = "#28c552";
const grey = "#EBEBEB";
const light_grey = "#e6e6ec";
const orange = "#df8243";
const red = "rgba(241, 11, 11, 1)";
const selection_colour_opaque = "rgba(99, 93, 255, 0.3)";
const start_base_button_colour = "rgba(29, 184, 198, 1)";
const start_base_button_colour_opaque = "rgba(29, 184, 198, 0.5)";
const true_black = "rgba(0, 0, 0, 1)";
const white = "#FFF";
const purple = "#7033AD";

const commonThemeVariables = {
  transparent: "rgba(0,0,0,0)",
  extra_small_font_size: 11,
  small_font_size: 14,
  semi_small_font_size: 12,
  base_font_size: 16,
  medium_font_size: 18,
  large_font_size: 22,
  largest_font_size: 24,
  fieldHeight: 30
};
//@todo: Enumns, split theme in components and get rid of the theme:{} object

const generateDarkTheme = {
  theme: {
    ...commonThemeVariables,
    secondary_button_background_colour: "rgba(246,249,252,1)",
    primary: start_base_button_colour,
    primary_soft: "rgba(29, 184, 198, 0.1)",
    primary_medium: "rgba(29, 184, 198, 0.5)",
    primary_hard: "rgba(29, 184, 198, 0.7)",
    message_bubble_background: "rgba(163, 163, 163, 0.05)",
    app_outline_color: "rgba(29, 184, 198, 0.2)",
    accent: end_base_button_colour,
    avatar_background_color: end_base_button_colour,
    avatar_foreground_color: white,
    backgroundColor: "rgba(32,32,33,1)",
    backgroundColorAppBorders: "rgba(41,41,43,1)",
    backgroundContrastColor: "rgba(59, 59, 59, 1)",
    backgroundHighContrastColor: "rgba(255,255,255,0.8)",
    backgroundPopupColor: "rgba(32,32,33,0.99)",
    bubble_color: "rgba(90, 90, 90, 1)",
    bubble_placeholder: "#c4c3c3",
    softBackgroundColor: "#272727",
    base_button_color: "#EC690B",
    base_button_font_color: white,
    shadowColor: "#000",
    baseScreenBackgroundColor: "rgba(32,32,33,1)",
    black: black,
    blue: blue,
    border: "1px solid rgba(246,246,246,0.25)",
    border_color: "rgba(246,246,246,0.25)",
    border_color_highlighted: "rgba(200,112,255,0.50)",
    box_shadow: "0 0px 0px ".concat(grey),
    contrast_font_color: white,
    custom_component_border: "0px solid transparent",
    tooltipBackgroundColor: "rgba(74,74,74,1)",
    darkGrey: "rgba(203,203,203,1)",
    darkestGrey: "rgba(45,45,45,1)",
    disabled_color: grey,
    editor_background_color: true_black,
    editor_foreground_color: white,
    end_base_button_colour: end_base_button_colour,
    end_base_button_colour_opaque: end_base_button_colour_opaque,
    end_skeleton_color: start_base_button_colour,
    font_bold: "bold",
    font_color: "white",
    font_normal: "normal",
    green: green,
    grey: "rgba(78,78,78,1)",
    highlight_selection_color: "#A828D4",
    inputBackgroundColor: true_black,
    inputPlaceholderColor: dark_grey,
    website_background_color: "rgba(35,35,35,1)",
    website_contrast_background_color: "rgba(33,33,33,1)",
    website_contrast_background_color_opaque: "rgba(37,37,37,1)",
    lightGrey: "#272727",
    link_color: "whitesmoke",
    link_color_hovered: "#858FEE",
    mediumGrey: "rgba(98, 98, 98, 1)",
    orangeBtnColor: "#E95E0B",
    pickerMenuColor: grey,
    purple: purple,
    red: red,
    orange: orange,
    orange_soft: "#ffd1ad",
    selectedTabColor: dark_blue,
    selection_color: start_base_button_colour,
    selection_colour_opaque: selection_colour_opaque,
    semi_transparent: "rgba(255, 255, 255, 0.5)",
    skeleton_color: "#202020",
    skeleton_highlight_color: "#444",
    slider_dark: start_base_button_colour,
    slider_light: end_base_button_colour,
    cardBackground: "#272727",
    start_base_button_colour: start_base_button_colour,
    start_base_button_colour_opaque: start_base_button_colour_opaque,
    start_skeleton_color: grey,
    true_black: true_black,
    white: white,
    yellow: "#ffca0094",
    tab_background: "rgba(205, 205, 205, 1)",
    nlp_title_color: "#272727"
  }
};
const generateBlueTheme = {
  theme: {
    ...(generateDarkTheme === null || generateDarkTheme === void 0 ? void 0 : generateDarkTheme.theme),
    backgroundColor: "#090d15",
    backgroundContrastColor: "#101a2f",
    lightGrey: "#101a2f"
    // mediumGrey: "#11192d",
    // darkGrey: "#1a3256",
  }
};

const generateLightTheme = {
  theme: {
    ...commonThemeVariables,
    secondary_button_background_colour: "rgba(246,249,252,1)",
    primary: start_base_button_colour,
    primary_soft: "rgba(29, 184, 198, 0.05)",
    primary_medium: "rgba(29, 184, 198, 0.5)",
    primary_hard: "rgba(29, 184, 198, 0.7)",
    message_bubble_background: "rgba(163, 163, 163, 0.05)",
    app_outline_color: "rgba(29, 184, 198, 0.2)",
    accent: end_base_button_colour,
    avatar_background_color: end_base_button_colour,
    avatar_foreground_color: white,
    backgroundColor: "#ffffff",
    backgroundContrastColor: "#f6f6ff",
    backgroundHighContrastColor: "#e8e8e8",
    backgroundPopupColor: "#f6f6ff",
    softBackgroundColor: "#F6F9FC",
    bubble_color: "rgba(232, 232, 232, 1)",
    bubble_placeholder: "rgba(176, 176, 176, 1)",
    base_button_color: "#EC690B",
    base_button_font_color: white,
    shadowColor: "#000",
    baseScreenBackgroundColor: white,
    backgroundColorAppBorders: "rgba(247,249,252,1)",
    black: black,
    blue: blue,
    border: "1px solid rgba(195,195,195,0.25)",
    border_color: "rgba(195,195,195,0.75)",
    border_color_highlighted: "rgba(99,93,255,0.50)",
    box_shadow: "0 1px 1px var(--light-grey)",
    contrast_font_color: white,
    custom_component_border: "1px solid rgba(195,195,195,0.25)",
    tooltipBackgroundColor: dark_grey,
    darkGrey: dark_grey,
    darkestGrey: "rgba(231,231,231,1)",
    disabled_color: "var(--medium-grey)",
    website_background_color: "rgba(245,245,245,1)",
    website_contrast_background_color: "rgba(243,243,243,0.8)",
    website_contrast_background_color_opaque: "rgba(247,247,247,1)",
    editor_background_color: white,
    editor_foreground_color: true_black,
    end_base_button_colour: end_base_button_colour,
    end_base_button_colour_opaque: end_base_button_colour_opaque,
    end_skeleton_color: start_base_button_colour,
    font_bold: "bold",
    font_color: "black",
    font_normal: "normal",
    green: green,
    grey: grey,
    purple: purple,
    highlight_selection_color: "#A828D4",
    inputBackgroundColor: "rgba(254,254,255,1)",
    inputPlaceholderColor: dark_grey,
    cardBackground: white,
    lightGrey: "rgba(239, 239, 239, 1)",
    link_color: "var(--dark-blue)",
    link_color_hovered: "purple",
    medium_font_size: 18,
    mediumGrey: "rgba(98, 98, 98, 1)",
    orangeBtnColor: "#E95E0B",
    pickerMenuColor: grey,
    red: red,
    orange: orange,
    orange_soft: "#ffd1ad",
    selectedTabColor: dark_blue,
    selection_color: start_base_button_colour,
    selection_colour_opaque: selection_colour_opaque,
    semi_transparent: "rgba(0, 0, 0, 0.5)",
    slider_dark: "#5e5e5e",
    slider_light: "#bdc3c7",
    start_base_button_colour: start_base_button_colour,
    start_base_button_colour_opaque: start_base_button_colour_opaque,
    start_skeleton_color: grey,
    true_black: true_black,
    white: white,
    yellow: "#ffca0094",
    tab_background: light_grey,
    nlp_title_color: "rgba(245,245,245,1)"
  }
};

let COLOR_MODE = /*#__PURE__*/function (COLOR_MODE) {
  COLOR_MODE["DARK"] = "dark";
  COLOR_MODE["LIGHT"] = "light";
  COLOR_MODE["BLUE"] = "blue";
  return COLOR_MODE;
}({});
const ThemeContext = /*#__PURE__*/createContext({
  mode: COLOR_MODE.LIGHT,
  setMode: mode => console.log("Theme changed" + mode),
  currentTheme: generateLightTheme
});
const useTheme = () => React__default.useContext(ThemeContext);
// export const ThemeProvider = React.createContext(initialState);
const ManageThemeProvider = _ref => {
  let {
    children,
    generateDarkThemeFn = generateDarkTheme,
    generateLightThemeFn = generateLightTheme,
    generateBlueThemeFn = generateBlueTheme,
    defaultColor = COLOR_MODE.LIGHT
  } = _ref;
  const defaultMode = defaultColor;
  let defaultTheme = defaultColor === "light" ? generateLightThemeFn : defaultColor === "blue" ? generateBlueThemeFn : generateDarkThemeFn;
  const [themeState, setThemeState] = useState(defaultMode);
  const [themeColors, setThemeColors] = useState(defaultTheme);

  //@todo: change setMode to accept the enum instead of the string, refactor rest of the app
  const setMode = m => {
    const mode = m === "light" ? COLOR_MODE.LIGHT : m === "blue" ? COLOR_MODE.BLUE : COLOR_MODE.DARK;
    setThemeState(mode);
    setThemeColors(mode === COLOR_MODE.DARK ? generateDarkThemeFn : mode === COLOR_MODE.BLUE ? generateBlueThemeFn : generateLightThemeFn);
  };
  return /*#__PURE__*/React__default.createElement(ThemeContext.Provider, {
    value: {
      mode: themeState,
      currentTheme: themeColors,
      setMode: setMode
    }
  }, children);
};
const ThemeManager = _ref2 => {
  let {
    children,
    defaultColor
  } = _ref2;
  return /*#__PURE__*/React__default.createElement(ManageThemeProvider, {
    defaultColor: defaultColor
  }, children);
};
ThemeManager.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ThemeManager"
};

export { ThemeManager as T, black as b, useTheme as u };
